// extracted by mini-css-extract-plugin
export default {"cartStatusContainer":"CartStatus_cartStatusContainer__C7Drr","cartIcon":"CartStatus_cartIcon__GokD9","cartValue":"CartStatus_cartValue__35ig6"};